import type { ReactElement } from 'react';
import { cloneElement } from 'react';

import type { IconProps } from '../../Icon';
import { cnTextinput } from '../Textinput.cn';

import './Textinput-Icon.css';
import './_side/Textinput-Icon_side_left.css';
import './_side/Textinput-Icon_side_right.css';

export interface ITextinputIconProps {
    /**
     * Компонент иконки для отображения.
     */
    component: ReactElement<IconProps>;

    /**
     * Расположение иконки.
     */
    side?: 'left' | 'right';
}

export const TextinputIcon = ({ component, side, ...props }: ITextinputIconProps) =>
    cloneElement(component, {
        ...props,
        className: cnTextinput('Icon', { side }, [component.props.className]),
    });
